import * as actionTypes from './constants';

const initialState = {
    toast: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.SET_DIALOG_TOAST:
            return {
                ...state,
                toast: { ...action.data, id: new Date().getTime() + Math.random() }
            };
        case actionTypes.CLOSE_DIALOG_TOAST:
            return {
                ...state,
                toast: null
            };
        default:
            return state;
    }
}
